import * as dayjs from "dayjs";
import { WorkWeek } from "./WorkWeek";
import { GlobalConstants } from "../constant/constant";
import { DateTimeHelper } from "../utils/date-time-helper";

export class ReviewPeriod {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;

  constructor(targetDate: dayjs.Dayjs) {
    const workWeek = new WorkWeek(targetDate);
    this.startDate = targetDate.day() === GlobalConstants.START_OF_WEEK ? workWeek.getPreviousWorkWeek().startDate : workWeek.startDate;
    this.endDate = workWeek.endDate.add(1, 'day');
  }

  static getCurrentReviewPeriod(): ReviewPeriod {
    return new ReviewPeriod(dayjs());
  }

  checkIsDateInReviewPeriod(targetDate: dayjs.Dayjs): boolean {
    return targetDate >= this.startDate && targetDate <= this.endDate;
  }

  getDatesInReviewPeriod(excludeFutureDates: boolean): dayjs.Dayjs[] {
    const dates: dayjs.Dayjs[] = [];
    let dateCursor = this.startDate;
    const lastDate = excludeFutureDates ? dayjs() : this.endDate;

    while (dateCursor.isSameOrBefore(lastDate)) {
      dates.push(dateCursor);
      dateCursor = dateCursor.add(1, 'day');
    }

    return dates;
  }

  /**
   * Gets the exact time when we should transition to the next review period.
   */
  getNextPeriodTransitionTime(): dayjs.Dayjs {
    // There are two shapes of a ReviewPeriod:
    // 1. Normal (created on any day except the start of week / Saturday):
    //    start = last Saturday, end = upcoming Saturday  (diff in days = 7)
    //    We transition at the moment that Saturday begins (Saturday 00:00) into the extended period.
    // 2. Extended (created on Saturday):
    //    start = previous Saturday, end = next Saturday  (diff in days = 14)
    //    We transition at the start of the next day (Sunday 00:00) back into the normal period.
    const dayDiff = DateTimeHelper.getDifference(this.endDate, this.startDate, 'day');
    const isExtended = dayDiff > 7; // 14 for extended, 7 for normal

    if (isExtended) {
      const tomorrow = DateTimeHelper.addTime(DateTimeHelper.getLocalNow(), 1, 'day');
      return DateTimeHelper.getStartOfDay(tomorrow);
    }

    // Normal period: transition at the start of the end Saturday -> Saturday 00:00
    return DateTimeHelper.getStartOfDay(this.endDate);
  }
}
